import AccountCreation from "@/components/signup/account-creation";
import { getWacIntegrationUrl } from "@/components/signup/utils";
import { useLoggedIn } from "@/components/user-context";

import { NoCreditCardRequired, SignupDefault } from "../components";

import { CreateYourAccount, DeveloperBundleTemplate } from "./components";

export const DeveloperBundleSignup = () => {
    const isLoggedIn = useLoggedIn();

    if (isLoggedIn) {
        return <SignupDefault />;
    }

    return (
        <DeveloperBundleTemplate>
            <CreateYourAccount />
            <AccountCreation
                Login={<NoCreditCardRequired />}
                getContinueUrl={() =>
                    `${getWacIntegrationUrl()}/try/cloud/signup?developer=true`
                }
            />
        </DeveloperBundleTemplate>
    );
};
